<script setup lang="ts">
// 外部エージェント接続（MCP）の管理ページ（#548 A2-5）。UserInfoCard のメニューから到達する。
definePageMeta({
  middleware: ['authenticated'],
  layout: 'default',
})
</script>

<template>
  <v-container class="agent-connections">
    <h1 class="page-title">
      外部エージェント接続
    </h1>
    <McpTokenManager />
  </v-container>
</template>

<style scoped>
.agent-connections {
  max-width: 720px;
  margin: 0 auto;
  padding-top: 24px;
  font-family: "Noto Sans JP", sans-serif;
}

.page-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 16px;
}
</style>
